<template>

    <!-- desktop -->
     <div ref="headerPlate" class="container blur" v-if="db.profile.id">       
        <Menu/>
        <!-- <Line/> -->
         <!-- {{ demo.settings.header }} -->
    </div>

   <!-- <tabbar v-if="db.profile.id" class="mobile"/> -->
    
</template>

<script setup>
    // import Line from './line.vue';
import Menu from './menu.vue';
</script>

<script>
export default {
    data: function () {return {               
        height: undefined,
    }},
    mounted() {
        this.getHeight()
    },
    methods: {
        getHeight(){
            // if (!this.$refs || !this.$refs.headerPlate) return
            this.demo.settings.header = this.$refs.headerPlate.clientHeight
        }
    },
    computed: {
    //   
    },   
}
</script>


<style scoped>
.container{
    display: flex;
    flex-direction: column;
    position: fixed;
    align-items: center;
    justify-content: center;
    top: 0;
    /* height: 30px; */
    width: 100vw;
    /* padding: 6px; */
    background-color: var(--back);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    backdrop-filter: saturate(180%) blur(20px);
    z-index: 10000000;

}

.blur {
  background: #1c1c1cd0;
  backdrop-filter: blur(50px);
  /* backdrop-filter: blur(50px) saturate(200%); */
  -webkit-backdrop-filter: blur(50px);
  /* -webkit-backdrop-filter: blur(50px) saturate(200%); */
  /* border: 1px solid rgba(255, 255, 255, 0.1); */
}
.logos{
    position: fixed;
    left: 60px;
    top: 40px;
    z-index:1000;
  }
</style>

